import React from 'react';

import TableDisplay from './TableDisplay';

import {Data} from '../services/data-manager';
import { Modal } from 'react-bootstrap';
import Moment from 'react-moment';
import Notification from 'react-notify-toast';

class Approvisionnements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            approvisionnements: [],
            page: 1,
            nbApprovisionnement: 1,
            sizeApprovisionnement: 50,
            approvisionnement: null,
            showDetail: false
        };
        this.getApprovisionnements = this.getApprovisionnements.bind(this);
        this.getDetailApprovisionnement = this.getDetailApprovisionnement.bind(this);
        this.showDetailModal = this.showDetailModal.bind(this);
    }
    componentDidMount() {
        this.props.isLoading(true);
        this.getApprovisionnements();
    }
    getApprovisionnements(page=0) {
        if (page!==0) {
            this.setState({page: page});
        } else {
            page = this.state.page;
        }
        this.props.isLoading(true);
        new Data()
        .get("Approvisionnement", "1", "utilisateur,client", "dateCreation DESC", page, this.state.sizeApprovisionnement)
        .then(res => {
            this.setState({approvisionnements: res.rows, nbApprovisionnement: res.count});
            this.props.isLoading(false);
        })
        .catch(err => {
            console.warn("Error : ", err);
            this.props.isLoading(false);
        });
        window.scrollTo(0,0);
    }
    getDetailApprovisionnement(approvisionnement) {
        this.setState({approvisionnement: approvisionnement}, () => {
            this.showDetailModal();
        });
    }
    showDetailModal(show=true) {
        this.setState({showDetail: show});
    }
    cancelApprovisionnement(approvisionnement) {
        window.confirm("Voulez vous vraiment supprimer la approvisionnement "+approvisionnement.idApprovisionnement);
    }
    render() {
        return (
            <div className="container-fluid">
                <Notification options={{top: "100px"}} />
                <div className="row">
                    <div className="col-sm-12 my-3">
                        <h3>Approvisionnements [Page {this.state.page}/{(this.state.nbApprovisionnement===0)?1:Math.ceil(this.state.nbApprovisionnement/this.state.sizeApprovisionnement)}]</h3>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <TableDisplay 
                            tableStriped={true}
                            tableHover={true}
                            thead="dark"
                            titles={["ID", "CLIENT", "MONTANT", "DEVISE", "DATE ET HEURE"]}
                            indices={["id", ["client.nom", "client.prenom"], "montant", "devise", "dateCreation"]}
                            data={this.state.approvisionnements}
                            actions={[
                                {caption: <i className='fa fa-list'></i>, className:"btn btn-sm btn-primary mr-1", onClick:this.getDetailApprovisionnement}
                            ]}
                            withPaging={true}
                            pagingTheme="primary"
                            nb={this.state.nbApprovisionnement}
                            size={this.state.sizeApprovisionnement}
                            current={this.state.page}
                            onChangePage= {this.getApprovisionnements}
                            withFooter={true} />
                    </div>
                </div>
                {(this.state.approvisionnement) &&
                <Modal show={this.state.showDetail} onHide={() => {this.showDetailModal(false)}} className="mt-5">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Détails de la approvisionnement #{this.state.approvisionnement.id}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mx-3">
                            <table className="table table-sm">
                                <tbody>
                                    <tr className="row">
                                        <td className="col-sm-5">ID : </td>
                                        <td className="col-sm-7">{this.state.approvisionnement.id}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Client : </td>
                                        <td className="col-sm-7">{this.state.approvisionnement.client.nom} {this.state.approvisionnement.client.prenom}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Montant : </td>
                                        <td className="col-sm-7">{Intl.NumberFormat().format(this.state.approvisionnement.montant)} {this.state.approvisionnement.devise}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Valeur réelle : </td>
                                        <td className="col-sm-7">{Intl.NumberFormat().format(this.state.approvisionnement.valeurReelle)} {this.state.approvisionnement.utilisateur.devise}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Date : </td>
                                        <td className="col-sm-7"><Moment format="DD/MM/YYYY à HH:mm">{this.state.approvisionnement.dateCreation}</Moment></td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Approvisionné par : </td>
                                        <td className="col-sm-7">{this.state.approvisionnement.utilisateur.nom} {this.state.approvisionnement.utilisateur.prenom}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
                }
            </div>
        );
    }
}

export default Approvisionnements;